import React from 'react';
import './Section.css';
import './Contact.css';
import contactUsImage from '../assets/contact-us.png';

const Contact = () => {
  return (
    <section id="contactus" className="section about-section">
      <div className="section-content about-container">
        <div className="about-image-container">
          <img src={contactUsImage} alt="Contact Us" className="about-image" />
        </div>
        <div className="about-text-container">
          <h1>Let's Build Something That Works.</h1>
          <p className="contact-lead">
            Whether you need a clinical system that keeps pace with your patients, a commercial platform
            that scales with your business, or a smarter way to connect the moving parts of your
            operation - Innodata is ready to deliver.
          </p>
          <p className="contact-body">
            We bring hands-on experience across a wide spectrum of industries: <strong>health and clinical
            systems</strong>, <strong>accounting and financial services</strong>, <strong>commercial property
            management</strong>, <strong>air and land port logistics</strong>, and broader <strong>commercial
            and enterprise sectors</strong>. That breadth means we don't just write code - we understand
            the domain, ask the right questions, and build solutions that actually fit the way your
            people work.
          </p>
          <p className="contact-body">
            From a first conversation to full delivery, our team is straightforward to work with,
            honest about what's possible, and committed to getting it right. Come, talk to us!
          </p>

          <div className="contact-details">
            <div className="contact-detail-item">
              <span className="contact-detail-icon">✉️</span>
              <div>
                <span className="contact-detail-label">Email</span>
                <a href="mailto:innodata.co.nz@gmail.com" className="contact-detail-value">
                  innodata.co.nz@gmail.com
                </a>
              </div>
            </div>
            <div className="contact-detail-item">
              <span className="contact-detail-icon">📍</span>
              <div>
                <span className="contact-detail-label">Based in</span>
                <span className="contact-detail-value">Christchurch, New Zealand</span>
              </div>
            </div>
          </div>

          <a href="mailto:innodata.co.nz@gmail.com" className="contact-cta">
            Get in touch →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
